import React from "react"
import {findDOMNode} from "react-dom"


import Popover from "../../../../../../gd-components/gd-popover/popover";
// @ts-ignore
import DatepickerContent from "../../../../../../gd-components/datetime/datepicker/datepicker-content";
import FieldProto from "../../../../../proto/field-proto"

const debug = false
// const debug = "FieldDate_Popover"

type Props = {
    parent      : any,
    field       : FieldProto
    value       : Moment | null
}

export default function FieldDate_Popover(props:Props) {

    const onSelect = (date:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(date)
    }

    debug && console.log(debug, 'render', props.value)

    return (
        <Popover attachment         = "top center"
                 targetAttachment   = "bottom center"
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            <DatepickerContent value        = {props.value}
                               onSelect     = {onSelect}
                               minDate      = {props.field.minDate}
                               maxDate      = {props.field.maxDate}/>
        </Popover>
    )
}
